<template>
  <modal v-bind="$attrs" v-on="$listeners" :center="true" :show-close="false">
    <template v-slot:body>
      <div :style="{ paddingBottom: 0 }">
        <h4 id="success-modal-message">
          {{ titlePopup }}
        </h4>
        <el-row class="body-info-modal" type="flex" style="width: 100%">
          <el-col id="creativity" :span="8">
            <div :style="{ display: 'flex' }"><img :src="imgLeft" :style="{ width: '100%' }" /></div>
          </el-col>
          <el-col :span="16">
            <ul class="list-none assignments">
              <li v-for="assignment in createdAssignments" :key="assignment.id" class="assignment">
                <div v-if="assignment.error && assignment.error.length">
                  <p class="info-row wrap-assignment-name">
                    <!-- {{ $t("study_sets.modals.createAssignmentSuccess.assignment_name") }}: -->
                    <span>{{ assignment.assignment_name[0] }}</span>
                    <!-- <i v-bind:class="page == 0 ? 'elsa-icon-exclamation-circle align-icon' : 'align-icon'" /> -->
                    <i :class="'elsa-icon-exclamation-circle align-icon icon-status'" />
                  </p>
                  <div class="info-row" :style="{ display: 'flex', gap: '6px' }">
                    <div>{{ isCompany ? $t("company_labels.group") : $t("school_labels.group") }}:</div>

                    <div
                      v-if="
                        assignment.organization &&
                          assignment.organization.length &&
                          assignment.group &&
                          assignment.group.length
                      "
                      :style="{ flex: '1' }"
                    >
                      <span>{{ assignment.organization[0] }}</span>
                      <span :style="{ fontSize: '18px', lineHieght: '24px', fontWeight: '600' }">・</span>
                      <span>{{ assignment.group[0] }}</span>
                    </div>
                  </div>
                  <p class="error-row" v-html="errorMessage(assignment)"></p>
                </div>
                <div v-else>
                  <p class="info-row wrap-assignment-name">
                    <!-- {{ $t("study_sets.modals.createAssignmentSuccess.assignment_name") }}: -->
                    <span>{{ assignment.name }}</span>
                    <!-- <i v-bind:class="page == 0 ? 'elsa-icon-check-circle align-icon' : 'align-icon'" /> -->
                    <i :class="'elsa-icon-check-circle align-icon icon-status'" />
                  </p>
                  <div class="info-row" :style="{ display: 'flex', gap: '6px' }">
                    <div>{{ isCompany ? $t("company_labels.group") : $t("school_labels.group") }}:</div>
                    <div :style="{ flex: '1' }">
                      <span>{{ assignment.organization_name }}</span>
                      <span :style="{ fontSize: '18px', lineHieght: '24px', fontWeight: '600' }">・</span>
                      <span>{{ assignment.group_name }}</span>
                    </div>
                  </div>
                  <p class="info-row">
                    {{ $t("common.due_by") }}:
                    <span>{{ formatDate(assignment.due_date) }}</span>
                  </p>
                  <p class="wrap-view-assignment">
                    <span
                      @click="handleClickViewAssignment(assignment.id, assignment.organization, assignment.group)"
                      class="view-assignment"
                    >
                      View Assignment
                    </span>
                  </p>
                </div>
              </li>
            </ul>
          </el-col>
        </el-row>
        <div :style="{ display: 'flex', justifyContent: 'flex-end' }">
          <primary-button class="assign-class" ref="" @click.native="$emit('closed')">
            {{ $t("common.finish") }}
          </primary-button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from "@/components/common/Modal";
import PrimaryButton from "@/components/common/buttons/PrimaryButton";
import { mapGetters } from "vuex";
import { format } from "date-fns";
import { DATE_FORMAT_WITH_TIME } from "@/constants/generic";
import { COMPANY } from "@/constants/organizationType";

export default {
  props: {
    dateFormat: {
      type: String,
      default: DATE_FORMAT_WITH_TIME,
    },
    page: {
      type: Number,
      default: 0,
    },
    createdAssignments: {},
  },
  components: {
    Modal,
    PrimaryButton,
    // TertiaryButton,
  },
  computed: {
    ...mapGetters({
      currentOrganizationType: "organization/currentOrganizationType",
    }),
    getIconUrl() {
      return require(`@/assets/images/notebook.svg`);
    },
    getIconUrl2() {
      return require(`@/assets/images/assignment-success.png`);
    },
    getIconUrl3() {
      return require(`@/assets/images/books.png`);
    },
    getTitle() {
      return this.$t(this.$i18nLabelsHelper(this.currentOrganizationType, "modals.delete.title"), {
        numberOfClasses: this.numberOfSelectedClasses,
      });
    },
    isCompany() {
      return this.currentOrganizationType === COMPANY;
    },
    organizationId() {
      return this.$store.state.organization.currentOrganizationId;
    },
    teamsAssignment() {
      return Object.values(this.createdAssignments).map(el => el.group);
    },
    onlyOneTeam() {
      return this.teamsAssignment.length === 1;
    },
    isAllSuccess() {
      return Object.values(this.createdAssignments).every(el => !el.study_set_used);
    },
    isAllFail() {
      return Object.values(this.createdAssignments).every(el => el.study_set_used);
    },
    titlePopup() {
      if (this.pagee === 0) return this.$t("study_sets.modals.createAssignmentSuccess.new_assignments_status");
      if (this.pagee === 1) return this.$t("homework.modals.create_success");

      if (this.isAllSuccess) {
        return "Your assignment has been sent";
      }
      if (this.isAllFail) {
        return "There was a problem creating the assignment";
      }

      return "There was a problem with some of your assignments";
    },
    imgLeft() {
      // if (this.page === 0) return this.getIconUrl;
      // if (this.page === 1) return this.getIconUrl2;

      return this.getIconUrl;
    },
  },
  methods: {
    errorMessage(assignment) {
      if (!assignment.error) return "";
      if (!assignment.study_set.length) return "";
      const studysetTitle = assignment.study_set.map(el => el.replace(",", ", ")).join(", ");
      const orgtext = this.isCompany ? this.$t("company_labels.group") : this.$t("school_labels.group");

      return this.$t("common.error_message.used", {
        studysetTitle,
        orgType: orgtext.toLowerCase(),
      });
    },
    formatDate(date) {
      return date ? format(new Date(date), this.dateFormat) : "--";
    },
    handleGotoAssignment() {
      this.$emit("closed");
      this.$router.push("/organization/" + this.organizationId + "/assignment-library");
    },
    handleClickSeeInTeam() {
      this.$router.push("/organization/" + this.organizationId + "/classes/" + this.teamsAssignment[0] + "#assignment");
    },
    handleClickViewAssignment(id, organization, group) {
      if (!id) {
        this.$emit("closed");
        return;
      }
      const url = `/organization/${organization}/classes/${group}/assignments/${id}`;
      if (organization != this.organizationId) {
        window.location.href = url;
      } else {
        this.$router.push(url);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../scss/_colors.scss";

.new-study-set {
  color: $hyperlink;
  padding-left: 0px !important;
  padding-bottom: 0px !important;
  margin-top: auto;
}

.new-study-set {
  &::v-deep span {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      height: 12px;
      width: 12px;
      fill: $hyperlink;
      padding-left: 0px;
    }
  }
}

.new-study-set:hover {
  color: $hyperlink;

  &::v-deep span {
    img {
      fill: $hyperlink-hover;
    }
  }
}

.assignment {
  background: #e7e7e7;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
}

.assignments {
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 32px;
  padding-bottom: 26px;
  > :last-child {
    margin-bottom: 0px;
    box-shadow: none;
  }
}
.detail {
  margin-top: 24px;
}
.info-row {
  margin: 0px 0px 8px 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: $black;
  span {
    font-size: 18px;
    font-weight: 600;
  }
}

.wrap-view-assignment {
  display: flex;
  justify-content: flex-end;
  padding: 0;
  margin: 0;
}
.view-assignment {
  color: #478dff;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  cursor: pointer;
}

.error-row {
  margin: 0px 0px 8px 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #e00700;
}

#success-modal-message {
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;

  color: $black;
  margin: 0 auto;
  white-space: pre-wrap;
}

.elsa-button.assign-class,
.elsa-button.assign-class:hover {
  border-radius: 8px;
  padding-left: 32px;
  padding-right: 32px;
  margin-left: 4px;
}

::v-deep {
  .el-dialog.elsa-modal {
    width: 720px;
    .el-dialog__header,
    .el-dialog__body {
      // display: flex;
      background-color: white;
    }

    &.signup .el-dialog__body {
      padding: 0;
    }

    .el-dialog__header {
      border-top-left-radius: 16px;
      border-top-right-radius: 16px;
      min-height: 27.5px;
      height: 40px;
      padding: 0;
      margin: 0;
    }

    .el-dialog__body {
      padding: 0px 32px 32px 32px;
      border-top: none;
      border-bottom-left-radius: 16px;
      border-bottom-right-radius: 16px;
      & > *:not(p):not(.info) {
        padding-bottom: 6px;
        display: flex;
        flex-direction: column;
      }
    }
    .el-dialog__body {
      div.body-info-modal.el-row {
        padding-top: 24px !important;
        padding-bottom: 24px !important;
      }
    }

    .el-dialog__footer {
      padding: 0 20px 48px 20px;
      justify-content: center;
    }
  }
}

.icon-status {
  &::before {
    width: 24px;
    height: 24px;
    padding-right: 0;
  }
}

.align-icon {
  display: inline-block !important;
  float: right !important;
}
.wrap-assignment-name {
  display: flex;
  justify-content: space-between;
}
#creativity {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  .img-2 {
    width: 142px;
    margin-top: 16px;
    align-self: initial;
  }
}
</style>
